// Forces Microsoft's account picker on every sign-in after a manual logout,
// until one completes. Entra can silently decline end-session, and without the
// picker the next sign-in would quietly reuse the same account.
//
// localStorage, not sessionStorage: other tabs race to sign-in as soon as the
// logout wipes storage, and must see the flag too. resetLogoutBrowserState
// preserves this key for that reason. Auto-logout does not set it.

import { AUTH_QUERY_VALUES, AUTH_SESSION_KEYS } from "@/constants/authFlowKeys";
import { authLocalStorage } from "@services/auth/authStorage";

const STORAGE_KEY = AUTH_SESSION_KEYS.FORCE_ACCOUNT_SELECTION;

// Must be called AFTER resetLogoutBrowserState — that clears storage.
export const markAccountSelectionRequired = () => {
  authLocalStorage.set(STORAGE_KEY, AUTH_QUERY_VALUES.TRUE);
};

export const isAccountSelectionRequired = () =>
  authLocalStorage.get(STORAGE_KEY) === AUTH_QUERY_VALUES.TRUE;

// Called once a sign-in completes, and when a flow abandons sign-in outright.
export const clearAccountSelectionRequired = () => {
  authLocalStorage.remove(STORAGE_KEY);
};
